import { Directive, ElementRef, Input, OnDestroy, OnInit } from '@angular/core';
import * as _ from 'lodash';
@Directive({
    selector: '[pLabelAligner]',
    exportAs: 'pLabelAligner'
})
export class LabelAlignerDirective implements OnInit, OnDestroy {
    private observer;
    @Input('pLabelAligner')
    className!: string;
    private _width: number | undefined;
    get width() {
        return this._width;
    }
    constructor(private el: ElementRef) {
        this.observer = new MutationObserver(this.scan);
    }
    ngOnInit(): void {
        this.setup();
    }
    private setup(): void {
        const config = { attributes: true, childList: true, subtree: true };
        this.observer.observe(this.el.nativeElement, config);
    }
    ngOnDestroy(): void {
        this.observer?.disconnect?.();
    }
    /*
    callback = (mutationsList, observer) => {
        // Use traditional 'for loops' for IE 11
        for (const mutation of mutationsList) {
            if (mutation.type === 'childList') {
                console.log('A child node has been added or removed.');
            } else if (mutation.type === 'attributes') {
                console.log('The ' + mutation.attributeName + ' attribute was modified.');
            }
        }
    }
*/
    private scan = () => {
        if (this.className) {
            const labels: any[] = Array.from(this.el.nativeElement.querySelectorAll(this.className));
            if (!_.isEmpty(labels)) {
                const max = _(labels).map('offsetWidth').max();
                if (max > 0) {
                    this._width = max;
                    _.each(labels, (el: any) => {
                        // set the min-width of the element itself
                        el.style.minWidth = max + 'px';
                    });
                    // console.log(labels[0]?.style?.minWidth);
                }
            }
        }
    };
}
